import { IsNumber, IsNumberString } from 'class-validator';

export class PosValidateStaffRequestDto {
  @IsNumberString()
  public posStaffNumber: string;

  @IsNumber()
  public posDeviceId: number;

  constructor(posAccessPin: string, posDeviceId: number) {
    this.posStaffNumber = posAccessPin;
    this.posDeviceId = posDeviceId;
  }
}
